import {html} from 'lit-html';
import {ifDefined} from 'lit-html/directives/if-defined';
import {live} from 'lit-html/directives/live';
import {classMap} from 'lit-html/directives/class-map';

import TemplateRegistry from '../template/template-registry';
import {
    valueSync, optionClassMap, optionName, optionAutocomplete
} from '../template/template-util.js';

TemplateRegistry.templates['color_input'] = (option, config, onChange) => html`
      <input type="text" class="cl-po--input ${classMap(optionClassMap(option))}" id="${option.id}" name="${optionName(option)}" .value=${live(option.value)} @change=${(e) => valueSync(e, option, onChange)} 
      ?required=${option.required} pattern="#[0-9A-Fa-f]{6}" placeholder=${ifDefined(option.params.placeholder)} autocomplete="${optionAutocomplete(option, 'color')}" form=${ifDefined(config.productFormLink)}>
`;